import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listDayforceWebhooks } from 'api/admin/dayforce/listDayforceWebhooks'
import { dayforceKeys } from './keys'

export const useDayforceWebhooksQuery = (
  request: Parameters<typeof listDayforceWebhooks>[0]
) => {
  return useQuery({
    queryKey: dayforceKeys.webhooksList(request),
    queryFn: () => listDayforceWebhooks(request),
    placeholderData: keepPreviousData,
  })
}
